export default "__VITE_ASSET__koWL74jL__"